import React, { useCallback, useState } from 'react';
import {
  Box, Paper, Stack, Tab, Tabs, Typography,
} from '@mui/material';

import CoquilleExpert from '../../../../components/Expert/CoquilleExpert';
import Logs from '../../../../components/Logs';
import ModalCreateExpertise from '../../../../components/Expmanage/modalCreateExpertise';
import TaskList from '../../../../components/Tasks/taskList';
import WeeklyTaskList from '../../../../components/Tasks/weeklyTaskList';
import { useNavigate } from 'react-router-dom';

const ONGLETS = [
  { cle: 'semaine', libelle: 'Tâches de la semaine', compteur: 'weeklyTasks' },
  { cle: 'toutes', libelle: 'Toutes les tâches', compteur: 'allTasks' },
  { cle: 'historique', libelle: 'Consultations', compteur: 'recentConsultations' },
];

/** Un chiffre, et ce qu'il compte. Rien d'autre : c'est un repère, pas un KPI. */
function Compteur({ libelle, valeur }) {
  return (
    <Paper variant="outlined" sx={{ p: 2, flex: 1, minWidth: 160 }}>
      <Typography variant="caption" color="text.secondary" component="div">
        {libelle}
      </Typography>
      <Typography variant="h1" sx={{ mt: 0.5 }}>{valeur}</Typography>
    </Paper>
  );
}

function Home() {
  const naviguer = useNavigate();
  const [onglet, setOnglet] = useState('semaine');
  const [compteurs, setCompteurs] = useState({});

  // Les enfants remontent ce qu'ils ont chargé : le tableau de bord ne
  // recompte pas, il affiche. Mémoïsé, sinon chaque rendu relance leur
  // effet et la page boucle.
  const majCompteurs = useCallback(
    (valeurs) => setCompteurs((etat) => ({ ...etat, ...valeurs })), []);

  return (
    <CoquilleExpert
      titre="Tableau de bord"
      sous_titre="Ce qui attend, et ce que vous avez ouvert récemment"
      actions={<ModalCreateExpertise
                 onCree={(id) => naviguer(`/edit-expertise/${id}`)} />}
    >
      <Stack spacing={3}>
        <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
          {ONGLETS.map(({ cle, libelle, compteur }) => (
            <Compteur key={cle} libelle={libelle}
                      valeur={compteurs[compteur] ?? '—'} />
          ))}
        </Stack>

        <Paper variant="outlined">
          <Tabs
            value={onglet}
            onChange={(_, valeur) => setOnglet(valeur)}
            variant="scrollable"
            scrollButtons="auto"
            sx={{ borderBottom: '1px solid', borderColor: 'divider' }}
          >
            {ONGLETS.map(({ cle, libelle }) => (
              <Tab key={cle} value={cle} label={libelle} />
            ))}
          </Tabs>

          {/* Les panneaux restent montés : changer d'onglet ne doit pas
              relancer un chargement ni perdre la semaine qu'on regardait. */}
          <Box sx={{ p: { xs: 2, md: 3 } }}>
            <Box hidden={onglet !== 'semaine'}>
              <WeeklyTaskList onUpdateStats={majCompteurs} />
            </Box>
            <Box hidden={onglet !== 'toutes'}>
              <TaskList onUpdateStats={majCompteurs} />
            </Box>
            <Box hidden={onglet !== 'historique'}>
              <Logs onUpdateStats={majCompteurs} />
            </Box>
          </Box>
        </Paper>
      </Stack>
    </CoquilleExpert>
  );
}

export default Home;
